module.exports = __webpack_public_path__ + "static/img/4.6ebef60c.png";